import React from 'react';
import { t, useBehaviorSubject } from '@base/utils/helpers';
import { ILanguageService } from '../../i18n/model/interfaces';
import { container } from 'tsyringe';
import styles from '../styles/languagePicker.module.scss';
import Flag from '@ui-kit/components/flag';

function LanguagePicker() {
  const languageService: ILanguageService = container.resolve('languageService');
  const selectedLanguage = useBehaviorSubject(languageService.currentLanguage);

  return (
    <div className={styles.languages}>
      {languageService
        .getAvailableLanguages()
        .sort((a, b) => (a === 'en' ? -1 : b === 'en' ? 1 : 0))
        .map((lang) => (
          <LanguageRadioSelector
            key={lang}
            onChange={() => languageService.setLanguage(lang)}
            language={lang}
            checked={selectedLanguage === lang}
          />
        ))}
    </div>
  );
}

function LanguageRadioSelector(props: { onChange: () => void; checked: boolean; language: string }) {
  const languageService: ILanguageService = container.resolve('languageService');
  return (
    <div className={styles.title}>
      <input type="radio" name="lang" checked={props.checked} onChange={props.onChange} id={props.language} />
      <Flag
        className={styles.flag}
        countryCode={languageService.languageToCountryCode(props.language)}
      />
      <span>{t(props.language.toLowerCase())}</span>
    </div>
  );
}

export default LanguagePicker;
